(function () {
  'use strict';

  var data = window.IDPCatalogArchitecture;
  if (!data) return;
  var productIndex = window.IDPProductSearchIndex || { products: [] };
  var indexedByHandle = {};

  (productIndex.products || []).forEach(function (product) {
    if (product && product.handle) indexedByHandle[product.handle] = product;
  });

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function productRecord(handle) {
    var meta = data.products[handle] || {};
    var indexed = indexedByHandle[handle] || {};
    if (!meta.title && !indexed.title) return null;
    return Object.assign({}, meta, indexed, {
      handle: handle,
      title: indexed.title || meta.title,
      familyCode: meta.familyCode || indexed.productType || '',
      family: meta.family || indexed.productType || '',
      solutions: meta.solutions || []
    });
  }

  function variantInfo(handle) {
    var meta = productRecord(handle);
    var shared = window.IDPVariantGroups;
    if (shared && meta) return shared.info(meta);
    var title = meta && meta.title ? meta.title : '';
    var seriesMatch = title.match(/^(.*?)\s*-\s*Serie\s+(.+?)\s+((?:N[ºo.]?\.?\s*)?\d+(?:\/\d+)?(?:\s*mm)?)$/i);
    if (seriesMatch) {
      var rawValue = seriesMatch[3].replace(/\s+/g, ' ').trim();
      var numberMatch = rawValue.match(/\d+(?:\/\d+)?/);
      var hasMillimeters = /\bmm\b/i.test(rawValue);
      var hasNumberPrefix = /^N/i.test(rawValue) || /[ºo.]/i.test(rawValue);
      return {
        baseTitle: (seriesMatch[1] + ' - Serie ' + seriesMatch[2]).replace(/\s+/g, ' ').trim(),
        label: hasMillimeters ? rawValue.replace(/\s*mm$/i, ' mm') : (hasNumberPrefix ? 'Nº ' + (numberMatch ? numberMatch[0] : rawValue) : rawValue),
        sort: numberMatch ? parseFloat(numberMatch[0].replace('/', '.')) : 9999
      };
    }

    var sizeMatch = title.match(/^(.*?)(?:\s+-)?\s+(\d+(?:\s*x\s*\d+)*(?:[.,]\d+)?\s*(?:mm|cm|m|kg|g|l|ml))$/i);
    if (!sizeMatch) return null;
    var sizeLabel = sizeMatch[2].replace(/\s+/g, ' ').trim();
    var sizeNumber = sizeLabel.match(/\d+(?:[.,]\d+)?/);
    return {
      baseTitle: sizeMatch[1].replace(/\s+/g, ' ').trim(),
      label: sizeLabel,
      sort: sizeNumber ? parseFloat(sizeNumber[0].replace(',', '.')) : 9999
    };
  }

  function variantSiblings(currentHandle) {
    var current = productRecord(currentHandle);
    var currentInfo = variantInfo(currentHandle);
    if (!current || !currentInfo) return [];
    var shared = window.IDPVariantGroups;
    var currentKey = shared ? shared.key(current, currentInfo) : normalize([current.familyCode, current.subfamilyCode, current.role, currentInfo.baseTitle].join('|'));
    var handles = Object.keys(data.products).concat(Object.keys(indexedByHandle)).filter(function (handle, index, values) {
      return values.indexOf(handle) === index;
    });
    return handles.map(function (handle) {
      var meta = productRecord(handle);
      var info = variantInfo(handle);
      if (!meta || !info) return null;
      var key = shared ? shared.key(meta, info) : normalize([meta.familyCode, meta.subfamilyCode, meta.role, info.baseTitle].join('|'));
      if (key !== currentKey) return null;
      return {
        handle: handle,
        title: meta.title,
        baseTitle: info.baseTitle,
        label: info.label,
        sort: info.sort
      };
    }).filter(Boolean).sort(function (a, b) {
      return (a.sort - b.sort) || a.label.localeCompare(b.label, 'es', { numeric: true });
    });
  }

  function renderVariantSelector(root, meta) {
    // Each construction system has its own prescription, document and public title.
    if (meta.familyCode === 'F10') return;
    var siblings = variantSiblings(root.dataset.productHandle);
    if (siblings.length < 2 || root.querySelector('[data-idp-product-sibling-variants]')) return;
    var price = root.querySelector('.idp-product__price');
    if (!price) return;
    var selectedByCustomer = new URLSearchParams(window.location.search).get('idp_variant') === '1';
    siblings.forEach(function (item) {
      var duplicateLabel = siblings.some(function (other) { return other.handle !== item.handle && other.label === item.label; });
      var pentriloReference = item.handle.match(/^pentrilo-(\d{5})-/);
      item.displayLabel = duplicateLabel && pentriloReference ? item.label + ' · Ref. ' + pentriloReference[1] : item.label;
    });
    var currentSibling = siblings.find(function (item) { return item.handle === root.dataset.productHandle; });
    var siblingLabels = siblings.map(function (item) { return item.label; }).join(' ');
    var choiceLabel = /(?:\b(?:mm|cm|m|kg|g|ml|l)\b|\u00d8)/i.test(siblingLabels) ? 'tamaño' : 'formato';
    var selector = document.createElement('nav');
    selector.className = 'idp-product-sibling-variants' + (selectedByCustomer ? ' is-selected' : ' is-required');
    selector.setAttribute('aria-label', 'Formatos disponibles');
    selector.setAttribute('data-idp-product-sibling-variants', '');
    selector.innerHTML = [
      '<div class="idp-product-sibling-variants__heading">',
      '<span>Selección obligatoria</span>',
      '<strong>Elige el ', escapeHtml(choiceLabel), ' antes de comprar</strong>',
      '<p>Selecciona una opción para confirmar el producto correcto y habilitar el carrito.</p>',
      '</div>',
      '<div class="idp-product-sibling-variants__options" role="radiogroup" aria-label="Elige el ', escapeHtml(choiceLabel), '">',
      siblings.map(function (item) {
        var active = selectedByCustomer && item.handle === root.dataset.productHandle;
        return '<a class="' + (active ? 'is-active' : '') + '" role="radio" aria-checked="' + (active ? 'true' : 'false') + '" href="/products/' + encodeURIComponent(item.handle) + '?idp_variant=1" title="' + escapeHtml(item.title) + '">' + escapeHtml(item.displayLabel) + '</a>';
      }).join(''),
      '</div>',
      '<p class="idp-product-sibling-variants__status" aria-live="polite">',
      selectedByCustomer && currentSibling
        ? 'Seleccionado: ' + escapeHtml(currentSibling.displayLabel)
        : 'Debes elegir una opción para continuar.',
      '</p>'
    ].join('');
    price.insertAdjacentElement('afterend', selector);
    var title = root.querySelector('.idp-product__info h1');
    if (title) title.textContent = siblings[0].baseTitle || meta.title;
    // Keep the public price visible; the selector still requires an explicit choice.
    var purchase = root.querySelector('[data-idp-product-purchase]');
    if (purchase) {
      purchase.dataset.requiresSiblingChoice = 'true';
      purchase.dataset.siblingChoiceSelected = selectedByCustomer ? 'true' : 'false';
      purchase.dataset.siblingChoiceLabel = choiceLabel;
      purchase.dispatchEvent(new Event('idp:sibling-variant-state'));
    }
  }

  document.querySelectorAll('[data-idp-product-page]').forEach(function (root) {
    var meta = productRecord(root.dataset.productHandle);
    var target = root.querySelector('[data-idp-product-solutions]');
    if (!meta) return;
    renderVariantSelector(root, meta);
    if (!target) return;
    target.innerHTML = (meta.solutions || []).map(function (code) {
      var label = data.solutions[code] || code;
      return '<a href="/pages/problemas-soluciones?solution=' + encodeURIComponent(code) + '">' + escapeHtml(label) + '</a>';
    }).join('');
  });

  document.querySelectorAll('[data-idp-related-products]').forEach(function (section) {
    var current = data.products[section.dataset.currentHandle];
    if (!current) return;
    var shown = 0;
    section.querySelectorAll('[data-idp-product-card]').forEach(function (card) {
      var candidate = data.products[card.dataset.productHandle];
      var sharesSolution = candidate && candidate.solutions.some(function (code) {
        return current.solutions.indexOf(code) !== -1;
      });
      var relevant = candidate && candidate !== current
        && (candidate.familyCode === current.familyCode || sharesSolution)
        && shown < 6;
      card.hidden = !relevant;
      if (relevant) shown += 1;
    });
    section.hidden = shown === 0;
  });
})();
